/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, ember/no-observers */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { observes } from '@ember-decorators/object';

const watchedRoutes = ['attendance.index', 'attendance.admin'];

export default class IndexRoute extends Route {
  @service
  dates;

  @service
  router;

  @observes('dates.today.id', 'router.currentRouteName')
  watchDate() {
    if (watchedRoutes.includes(this.router.currentRouteName)) {
      this.goToToday();
    }
  }

  activate() {
    super.activate(...arguments);
    this.goToToday();
  }

  goToToday() {
    let dateId = this.get('dates.today.id');
    if (dateId) {
      this.router.transitionTo(`/attendance/${dateId}`);
    }
  }
}
